/**
 * Strip a leading "#" hash from the URL after the page has loaded.
 * Keeps the address bar clean for share/copy without affecting in-page anchors.
 */
window.addEventListener('load', function () {
    if (window.location.hash) {
        var clean = window.location.pathname + window.location.search;
        window.history.replaceState(null, document.title, clean);
    }
});
